import { useEffect, useMemo, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "./embed.module.scss";
import { useEvotorLoginMutation } from "../screens/auth/store/auth.api";

const EVOTOR_USER_ID = "user_id";
const EVOTOR_TOKEN = "token";
const IFBX_TOKEN = "auth_token";

/**
 * Точка входа iframe: https://…/embed?evotor_user_id=…&token=…&auth_token=…
 * Обмен auth_token на сессию iFoodBox выполняется через backend.
 */
export const EmbedEntryScreen = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [evotorLogin, { isLoading, isError }] = useEvotorLoginMutation();
  const authStartedRef = useRef(false);
  const evotorUserId = searchParams.get(EVOTOR_USER_ID);
  const tokenPresent = searchParams.get(EVOTOR_TOKEN);
  const ifbxToken = searchParams.get(IFBX_TOKEN)?.trim() ?? "";

  useEffect(() => {
    if (!evotorUserId || !tokenPresent || !ifbxToken || authStartedRef.current) {
      return;
    }

    authStartedRef.current = true;

    evotorLogin({ ifbxToken })
      .unwrap()
      .then((response) => {
        if (response.status) {
          navigate("/", { replace: true });
          return;
        }

        authStartedRef.current = false;
      })
      .catch(() => {
        authStartedRef.current = false;
      });
  }, [evotorLogin, evotorUserId, ifbxToken, navigate, tokenPresent]);

  const hint = useMemo(() => {
    if (!evotorUserId && !tokenPresent) {
      return "Откройте приложение из личного кабинета Эвотор.";
    }
    if (!tokenPresent) {
      return "Не передан токен сессии (token).";
    }
    if (!ifbxToken) {
      return "Не передан токен iFoodBox (auth_token).";
    }
    if (!evotorUserId) {
      return "Не передан идентификатор пользователя Эвотор (evotor_user_id).";
    }
    if (isError) {
      return "Не удалось выполнить авторизацию через Эвотор.";
    }
    return null;
  }, [evotorUserId, ifbxToken, isError, tokenPresent]);

  return (
    <div className={styles.embedEntry}>
      <h1 className={styles.embedTitle}>iFoodBox</h1>
      {hint ? (
        <p className={styles.embedHint}>{hint}</p>
      ) : (
        <p className={styles.embedReady}>
          {isLoading ? "Выполняем авторизацию..." : "Авторизация выполнена. Переходим на главную..."}
        </p>
      )}
    </div>
  );
};
